module.exports = __webpack_public_path__ + "img/menucn-4-6.34d3c4d1.svg";